import { useState, useMemo, ReactNode } from 'react';
import { IconButton, Text, Icon } from '@intellecteu/common-ui';
import cx from 'classnames';

import s from './styles.module.scss';

type CopyTextProps = {
  value: string | ReactNode;
  copyValue?: string;
  valueClassName?: string;
  className?: string;
  isShowingCopy?: boolean;
  defaultText?: string;
  textAfterAction?: string;
};

export const CopyText = ({
  value,
  isShowingCopy = true,
  className,
  valueClassName,
  defaultText: defaultTextProp,
  textAfterAction: textAfterActionProp,
  copyValue,
}: CopyTextProps) => {
  const defaultText = useMemo(() => defaultTextProp || 'Copy', []);
  const textAfterAction = useMemo(() => textAfterActionProp || 'Copied', []);
  const [copyText, setCopyText] = useState(defaultText);

  const clipboardValue = copyValue ?? (typeof value === 'string' ? value : '');

  return (
    <div className={cx(s.text, className)}>
      {typeof value === 'string' ? (
        <Text className={cx(s.textValue, valueClassName)}>{value}</Text>
      ) : (
        <span className={cx(s.textValue, valueClassName)}>{value}</span>
      )}
      {isShowingCopy && (
        <IconButton
          className={s.textBtn}
          iconName={copyText === textAfterAction ? Icon.icons.running : Icon.icons.copy}
          iconSize="s"
          onBlur={() => {
            setCopyText(defaultText);
          }}
          onClick={(e) => {
            e.preventDefault();
            setCopyText(textAfterAction);
            navigator.clipboard.writeText(clipboardValue);
          }}
          tooltipText={copyText}
        />
      )}
    </div>
  );
};
